<template>
  <div class="menu-container">
    <div class="button-container" @click="openMenu">
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="12" fill="white" fill-opacity="0.2"/>
            <line x1="6.5" y1="9.5" x2="17.5" y2="9.5" stroke="white" stroke-linecap="round"/>
            <line x1="6.5" y1="14.5" x2="17.5" y2="14.5" stroke="white" stroke-linecap="round"/>
        </svg>
    </div>
    <transition name="menu">
      <div v-if="isOpen" class="modal-menu-container">
          <div class="menu-items">
            <div class="close-button" @click="closeMenu">x</div>
              <a href="#about" @click="closeMenu">{{ $t('header.menu.about') }}</a>
              <a href="#portfolio" @click="closeMenu">{{ $t('header.menu.portfolio') }}</a>
              <a href="#experience" @click="closeMenu">{{ $t('header.menu.experience') }}</a>
              <a href="#team" @click="closeMenu">{{ $t('header.menu.team') }}</a>
              <a href="#contact" class="underline" @click="closeMenu">{{ $t('header.menu.contact') }}</a>
          </div>
          <div class="contact-block">
              <p><i>{{ $t('mobileMenu.joke') }}</i></p>
          </div>
      </div>
    </transition>
    <transition name="overlay">
      <div v-if="isOpen" class="overlay" @click="closeMenu"></div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "MobileMenu",
  data() {
    return {
      isOpen: false
    }
  },
  methods: {
    openMenu() {
      this.isOpen = true;
      document.body.style.overflow = 'hidden';
    },
    closeMenu() {
      this.isOpen = false;
      document.body.style.overflow = '';
    }
  }
};
</script>

<style scoped>
.button-container {
  padding: 0;
  margin: 0;
  cursor: pointer;
}

.button-container:hover {
  opacity: 0.5;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 998;
}

.modal-menu-container {
    position: fixed;
    width: 30vw;
    top: 0;
    right: 0;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 32px;
    background-color: #1f1f1f;
    -webkit-backdrop-filter: blur(20px);
    backdrop-filter: blur(20px);
    z-index: 999;
}

.close-button {
    cursor: pointer;
    user-select: none;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: end;
    font-size: clamp(12px, 1.25vw, 24px);
    font-weight: 300;
}

.close-button:hover {
    opacity: 0.5;
}

.menu-items {
    display: flex;
    flex-direction: column;
    gap: 32px;
}

.menu-items a {
    text-decoration: none;
    color: #fff;
    transition: all 0.25s;
    font-size: clamp(10px, 0.83vw, 16px);
}

.menu-items a:hover {
    opacity: 0.5;
    transition: all 0.25s;
}

/* Анимации для меню */
.menu-enter-active,
.menu-leave-active {
  transition: transform 0.3s ease-in-out;
}

.menu-enter-from {
  transform: translateX(100%);
}

.menu-leave-to {
  transform: translateX(100%);
}

/* Анимации для overlay */
.overlay-enter-active,
.overlay-leave-active {
  transition: opacity 0.3s ease-in-out;
}

.overlay-enter-from,
.overlay-leave-to {
  opacity: 0;
}

@media screen and (max-width: 1024px) {
  .modal-menu-container {
    width: 50vw;
  }
}

@media screen and (max-width: 768px) {
  .modal-menu-container {
    width: 70vw;
  }
}
</style>
